import { Routes, Route, Navigate } from 'react-router-dom'
import { PageShell } from './components/site-layout'
import 'sweetalert2/dist/sweetalert2.min.css'
import './styles.css'

// ============================================
// TEMPORARY PRODUCTION MODE - WAITLIST ONLY
// ============================================
// Temporary production mode while the Revocube Energies training application is being completed.
// Set to false when the full application is ready to launch.
const WAITLIST_ONLY_MODE = true;
// ============================================

// Import route components
import HomePage from './routes/index'
import AboutPage from './routes/about'
import CurriculumPage from './routes/curriculum'
import StructurePage from './routes/structure'
import AdmissionsPage from './routes/admissions'
import ApplyPage from './routes/apply'
import RegisterPage from './routes/register'
import ContactPage from './routes/contact'
import PrivacyPage from './routes/privacy'
import TermsPage from './routes/terms'
import AdminLoginPage from './routes/admin.login'
import AdminDashboardPage from './routes/admin.dashboard'
import PaymentSuccessPage from './routes/payment.success'
import PaymentFailedPage from './routes/payment.failed'
import PaymentCallbackPage from './routes/payment.callback'
import WaitlistPage from './routes/waitlist'

function NotFound() {
  return (
    <PageShell>
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <div className="max-w-md text-center">
          <h1 className="text-7xl font-bold gradient-text">404</h1>
          <h2 className="mt-4 text-xl font-semibold text-foreground">Page not found</h2>
          <p className="mt-2 text-sm text-muted-foreground">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="mt-6">
            <a href="/" className="btn-primary text-sm">Go home</a>
          </div>
        </div>
      </div>
    </PageShell>
  )
}

function App() {
  if (WAITLIST_ONLY_MODE) {
    return (
      <Routes>
        <Route path="/" element={<Navigate to="/waitlist" replace />} />
        <Route path="/about" element={<Navigate to="/waitlist" replace />} />
        <Route path="/curriculum" element={<Navigate to="/waitlist" replace />} />
        <Route path="/structure" element={<Navigate to="/waitlist" replace />} />
        <Route path="/admissions" element={<Navigate to="/waitlist" replace />} />
        <Route path="/apply" element={<Navigate to="/waitlist" replace />} />
        <Route path="/register" element={<Navigate to="/waitlist" replace />} />
        <Route path="/contact" element={<Navigate to="/waitlist" replace />} />
        <Route path="/privacy" element={<Navigate to="/waitlist" replace />} />
        <Route path="/terms" element={<Navigate to="/waitlist" replace />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/failed" element={<PaymentFailedPage />} />
        <Route path="/payment/callback" element={<PaymentCallbackPage />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="*" element={<Navigate to="/waitlist" replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/curriculum" element={<CurriculumPage />} />
      <Route path="/structure" element={<StructurePage />} />
      <Route path="/admissions" element={<AdmissionsPage />} />
      <Route path="/apply" element={<ApplyPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
      <Route path="/payment/success" element={<PaymentSuccessPage />} />
      <Route path="/payment/failed" element={<PaymentFailedPage />} />
      <Route path="/payment/callback" element={<PaymentCallbackPage />} />
      <Route path="/waitlist" element={<WaitlistPage />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App